<template>
  <login-card-shell
    title="ระบบบุคลากรการศึกษา"
    subtitle="ครูอัตราจ้าง ลูกจ้างประจำ ลูกจ้างชั่วคราว"
    username-hint="Username: รหัสบัตรประชาชน"
    password-hint="Password: รหัสบัตรประชาชน"
    notice-text="เข้าใช้งานได้ทันที"
    logo-icon-src="https://cdn.lordicon.com/knzzcfyy.json"
    theme-color-start="#f57c00"
    theme-color-end="#e65100"
    :dialog-value="dialogLogin"
    @update:dialogValue="dialogLogin = $event"
    :snackbar-value="dialog"
    @update:snackbarValue="dialog = $event"
    :snackbar-msg="dialog_msg"
    :loading="loading"
    :lockout-message="lockoutMessage"
    @submit="userEtcLogin"
  >
    <template v-slot:extra-action>
      <reset-password-dialog person-type="personnel_etc" />
    </template>

    <v-form ref="form" lazy-validation>
      <v-text-field
        color="orange"
        prepend-icon="mdi-account"
        name="login"
        label="ชื่อผู้ใช้งาน : รหัสบัตรประชาชน"
        type="text"
        v-model="personnel_etc_id_card"
        :rules="[v => !!v || 'กรุณากรอกชื่อผู้ใช้งาน']"
        rounded
        outlined
        class="enhanced-input mb-4"
      ></v-text-field>

      <v-text-field
        color="orange"
        name="password"
        label="รหัสผ่าน : รหัสบัตรประชาชน"
        prepend-icon="mdi-lock-outline"
        id="password"
        v-model="personnel_etc_pass"
        rounded
        :rules="[v => !!v || 'กรุณากรอกรหัสผ่าน']"
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show1 ? 'text' : 'password'"
        @click:append="show1 = !show1"
        outlined
        class="enhanced-input"
        hint="ใช้รหัสบัตรประชาชนเดียวกันกับ Username"
        persistent-hint
      ></v-text-field>
    </v-form>
  </login-card-shell>
</template>

<script>
import LoginCardShell from "./LoginCardShell.vue";
import resetPasswordDialog from "./ResetPasswordDialog.vue";

const VALID_M_TYPES = [
  "governmentteach", "governmentsp", "government", "temporary", "temporary_job", "permanent"
];

export default {
  components: { LoginCardShell, resetPasswordDialog },
  data() {
    return {
      ApiKey: "HRvec2021",
      show1: false,
      dialogLogin: false,
      personnel_etc_id_card: "",
      personnel_etc_pass: "",
      dialog: false,
      dialog_msg: "",
      loading: false,
      lockoutMessage: ""
    };
  },
  methods: {
    async userEtcLogin() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.lockoutMessage = "";
      try {
        let result = await this.$http.post("login_etc.php?crud=user", {
          personnel_etc_id_card: this.personnel_etc_id_card,
          personnel_etc_pass: this.personnel_etc_pass
        });

        if (result.data.user_status === "Locked") {
          const minutes = Math.ceil((result.data.retry_after || 0) / 60);
          this.lockoutMessage = `ล็อกอินผิดเกินกำหนด กรุณารออีกประมาณ ${minutes} นาที`;
          return;
        }

        if (result.data.personnel_etc_m_type) {
          let user = result.data;
          user.system_lock = false;

          if (VALID_M_TYPES.includes(user.personnel_etc_m_type)) {
            sessionStorage.setItem("user", JSON.stringify(user));
            sessionStorage.setItem(
              "force_password_change",
              user.must_change_password ? "1" : "0"
            );
            this.dialogLogin = false;
            this.dialog = true;
            this.dialog_msg = "เข้าสู่ระบบสำเร็จ - บุคลากรการศึกษา";
            setTimeout(() => {
              this.$router.push("/userEtc");
            }, 1500);
          } else {
            sessionStorage.clear();
            this.dialog = true;
            this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
          }
        } else {
          sessionStorage.clear();
          this.dialog = true;
          this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
        }
      } catch (error) {
        this.dialog = true;
        this.dialog_msg = "เกิดข้อผิดพลาดในการเข้าสู่ระบบ";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.enhanced-input .v-input__control {
  transition: all 0.3s ease;
}

.enhanced-input:hover .v-input__control {
  transform: translateY(-1px);
}
</style>
